import { type ReactNode } from 'react';
import { Button } from 'src/components/Button';
import { Link } from 'src/components/Link';
import { Stack } from 'src/components/Stack';

import { BlockingReasonAction, isBlockingReasonLinkAction } from './_types';
import { blockingReasonLinkSx } from './blockingReasonStyles';

export function ActionsList({
  actions,
}: {
  actions: ReactNode | BlockingReasonAction[];
}) {
  if (!Array.isArray(actions)) {
    return <Stack sx={{ width: '100%' }}>{actions}</Stack>;
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={1.5}
      alignItems={{ xs: 'stretch', sm: 'center' }}
      justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}
      sx={{ width: { xs: '100%', md: 'auto' } }}
    >
      {actions.map((action, i) => {
        if (isBlockingReasonLinkAction(action)) {
          return (
            <Link
              key={action.label ?? i}
              component="button"
              type="button"
              onClick={action.onClick}
              sx={[
                blockingReasonLinkSx,
                {
                  alignSelf: { xs: 'stretch', sm: 'auto' },
                  width: { xs: '100%', sm: 'auto' },
                  textAlign: { xs: 'left', sm: 'inherit' },
                },
              ]}
            >
              {action.label}
            </Link>
          );
        }

        const { sx: actionSx, ...buttonRest } = action;
        const mergedSx = [
          {
            alignSelf: { xs: 'stretch', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: 'min-content' },
          },
          ...(Array.isArray(actionSx) ? actionSx : actionSx ? [actionSx] : []),
        ];

        return (
          <Button
            key={action.label?.toString() ?? i}
            {...buttonRest}
            sx={mergedSx}
          >
            {action.children || action.label}
          </Button>
        );
      })}
    </Stack>
  );
}
